import MfText from './mf_text'
export {TEXT_STYLES} from './mf_text'

export default MfText
